/**
 * Created by satans17 on 2017/1/5.
 */
import $ from '@ali/tarzan-zepto';
import BaseUI from '../../component/baseui/index';

export default function (app) {
  app.$ = $;
  app.BaseUI = BaseUI;
  Object.assign(app, {
    appendSystemMessage(text) {
      this.postMessage({
        type: 'system',
        body: {
          text,
        },
      }).then((ret) => {
        this.view.body.append(ret.body);
      });
    },
  });

  Object.assign(app, {
    appendMessage(data, $container = this.view.body) {
      this.postMessage(data).then((ret) => {
        $container.append(ret.body);
      });
    },
  });

  Object.assign(app.util, {
    confirm(param) {
      return new Promise((resolve) => {
        if (window.confirm(param.message)) {
          resolve();
        }
      });
    },
  });

  Object.assign(app.util, {
    openWindow(originUrl, callback) {
      const url = originUrl;
      if (callback) {
        callback();
      }
      // eslint-disable-next-line
      if (url.length === 0 || url === '#' || url === 'javascript:;' || url.indexOf('tel:') === 0) {
        return;
      }
      window.open(url);
    },
  });
}



// WEBPACK FOOTER //
// ./src/app/context/index.js